export const mailAndUrlRegexp =
  /(^(\s+|$)|(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))?(\s+|$))|((https?:\/\/[^\s]+)?(([a-z0-9\-]+\.)+([a-z]{2}|biz|com|edu|gov|info|jobs|net|org|pro|local|internal))(:[0-9]{1,5})?(\/[a-z0-9_\-\.~]+)*(\/([a-z0-9_\-\.]*)(\?[a-z0-9+_\-\.%=&amp;]*)?)?(#[a-zA-Z0-9-=!$&'()*+.=_~:@/?%]*)?)(\s+|$)/gim;

export const urlRegexp =
  /((https?:\/\/[^\s]+)?(([a-z0-9\-\%]+\.)+([a-z]{2}|biz|com|edu|gov|info|jobs|net|org|pro|local|internal))(:[0-9]{1,5})?(\/[a-z0-9_\-\.~]+)*(\/([a-z0-9_\-\%\.]*)(\?[a-z0-9+_\-\.%=&amp;]*)?)?(#[a-zA-Z0-9-=!$&'()*+.=_~:@/?%]*)?)(\s|$)/gim;

const httpRegexp = /^(?:(?:https?):\/\/)/i;
export const emailRegexp =
  /(^(\s+|$)|(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))?(\s+|$))/i;

export const wrapURLs = (taskTitle: string, targetBlank = true): string =>
  taskTitle.replace(mailAndUrlRegexp, url => {
    if (!url) return taskTitle;
    if (emailRegexp.test(url)) {
      return `<a href="mailto:${url}" target="_blank">${url}</a> `;
    } else if (httpRegexp.test(url)) {
      return `<a href="${url}" ${targetBlank ? 'target="_blank"' : ''} >${url}</a> `;
    } else {
      return `<a href="http://${url}" ${targetBlank ? 'target="_blank"' : ''} >${url}</a> `;
    }
  });
